import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fillings',
  templateUrl: './fillings.component.html',
  styleUrls: ['./fillings.component.scss']
})
export class FillingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
